( function( app ) {
  const COMPONENT = {
    init: function() {
      let currentSlider = $( '.featured-services-tabs__tab-content' ).attr( 'id' );

      $( document ).on( 'change', '.js-featured-services-tabs__form', function( event ) {
        event.preventDefault();
        const formData = $( this ).serializeArray();

        let updatedSlider = currentSlider;
        let inputType = '';
        $( formData ).each( function( index, value ) {
          if ( value.value !== currentSlider ) {
            updatedSlider = value.value;
            inputType = value.name;
          }
        } );

        $( `#${currentSlider}` ).removeClass( 'is-open' );
        $( `#${currentSlider}` ).attr( 'aria-hidden', true );
        $( `#${updatedSlider}` ).addClass( 'is-open' );
        $( `#${updatedSlider}` ).attr( 'aria-hidden', false );

        currentSlider = updatedSlider;

        const select = $( this ).find( '.featured-services-tabs__select' );
        const announcement = $( this ).siblings( '.featured-services-tabs__announcement' );

        if ( inputType === 'featured-service-select' ) {
          $( this ).find( `.featured-services__radio-input[value="featured-services-tabs-tab-${currentSlider}"]` ).prop( 'checked', true );
        } else {
          select.val( currentSlider );
        }

        const selectedTitle = $( `#${select.attr( 'id' )} option:selected` ).text();
        announcement.text( `${selectedTitle} slider is displayed` );

        return false;
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'featured-services-tabs', COMPONENT );
} )( app );
